// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.8241 17.0939H5.2372L4.56662 20.8972C4.5186 21.1737 4.73055 21.427 5.01036 21.427H19.2198C19.4383 21.427 19.6254 21.2697 19.6635 21.0544L20.2679 17.6238C20.3159 17.3473 20.1039 17.0939 19.8241 17.0939Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5495 2.57324H8.95264C8.73409 2.57324 8.54698 2.73054 8.5089 2.94578L7.81019 6.90628H21.9451C22.1637 6.90628 22.3508 6.74898 22.3888 6.53374L22.9932 3.10308C23.0412 2.82657 22.8293 2.57324 22.5495 2.57324Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.95892 7.66791C2.74036 7.66791 2.55327 7.8252 2.51518 8.04044L1.81646 12.0009H6.13791L6.90286 7.66791H2.95892Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.67442 7.66791L6.90947 12.0009H10.8518C11.0703 12.0009 11.2574 11.8437 11.2955 11.6284L11.9942 7.66791H7.67276H7.67442Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5.23554 17.0973L6.00048 12.7642H1.67904L1.00681 16.5674C0.958795 16.8439 1.17074 17.0973 1.45055 17.0973H5.23554Z"}}]};

const LogoCodesignIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-codesign',
    ref,
    icon: element,
  },
));

LogoCodesignIcon.displayName = 'LogoCodesignIcon';

export default LogoCodesignIcon;
